import { Button, Flex, Layout } from "antd";
import {
  type Dispatch,
  memo,
  type ReactNode,
  type SetStateAction,
  useCallback,
} from "react";
import { AiOutlineMenuFold, AiOutlineMenuUnfold } from "react-icons/ai";

import { ThreddLogo } from "design-system/icons";

import s from "./Header.module.css";

const { Header: AntHeader } = Layout;

export interface HeaderProps {
  children?: ReactNode;
  collapsed: boolean;
  onCollapse: Dispatch<SetStateAction<boolean>>;
}

interface HeaderLogoProps {
  collapsed: boolean;
  onToggle: () => void;
}

const HeaderLogo = memo(({ collapsed, onToggle }: HeaderLogoProps) => (
  <Flex align="center" gap="small">
    <Button
      type="text"
      onClick={onToggle}
      aria-label={collapsed ? "Expand menu" : "Collapse menu"}
    >
      {collapsed ? <AiOutlineMenuUnfold /> : <AiOutlineMenuFold />}
    </Button>
    <ThreddLogo width={80} height={32} role="img" aria-label="Thredd" />
  </Flex>
));

export const Header = memo(
  ({ collapsed, onCollapse, children }: HeaderProps) => {
    const handleToggleMenu = useCallback(() => {
      onCollapse(prev => !prev);
    }, [onCollapse]);

    return (
      <AntHeader className={s.header} data-testid="header">
        <Flex justify="space-between" gap="large" align="center" flex={1}>
          <HeaderLogo collapsed={collapsed} onToggle={handleToggleMenu} />
          <Flex gap="sm" className={s.headerActions}>
            {children}
          </Flex>
        </Flex>
      </AntHeader>
    );
  },
);
